import React from 'react';
import { Card } from 'react-bootstrap';

const MerchandiseCard = ({ item, handleItemClick }) => {
  const handleModalShow = () => handleItemClick(item);

  return (
    <Card
      onClick={handleModalShow}
      className="h-100 d-flex flex-column justify-content-between text-center"
      style={{ cursor: 'pointer', height: '100%' }}
    >
      <Card.Img
        variant="top"
        src={item.picture[0].url}
        alt={item.name}
        className="card-image"
        style={{ objectFit: 'cover', maxHeight: '200px' }}
        onMouseOver={(e) => {
          if (item.picture.length > 1) {
            e.target.src = item.picture[1].url;
          }
        }}
        onMouseOut={(e) => {
          e.target.src = item.picture[0].url;
        }}
      />
      <Card.Body className="d-flex flex-column">
        <Card.Title className="card-title mb-2" style={{ fontSize: '1rem' }}>
          {item.name}
        </Card.Title>
        <Card.Text className="card-text" style={{ fontSize: '0.875rem' }}>
          <em>{item.company_name}</em>
        </Card.Text>
        <Card.Text className="card-text mb-2" style={{ fontSize: '1rem' }}>
          <strong>${item.price}</strong>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default MerchandiseCard;
